import type { FC } from "react";

export const HeadMetaData: FC = () => {
	return (
		<>
			{/* Files can be found in BabyBjorn Redesign Prod space in Storyblok */}
			<link
				rel="apple-touch-icon"
				sizes="180x180"
				href="https://a.storyblok.com/f/187315/180x180/842212af73/apple-touch-icon.png"
			/>
			<link
				rel="icon"
				type="image/png"
				sizes="16x16"
				href="https://a.storyblok.com/f/187315/512x512/7499e4db49/android-chrome-512x512.png/m/16x16"
			/>
			<link
				rel="icon"
				type="image/png"
				sizes="32x32"
				href="https://a.storyblok.com/f/187315/512x512/7499e4db49/android-chrome-512x512.png/m/32x32"
			/>
			<link
				rel="shortcut icon"
				type="image/png"
				sizes="48x48"
				href="https://a.storyblok.com/f/187315/512x512/7499e4db49/android-chrome-512x512.png/m/48x48"
			/>
			<link
				rel="icon"
				type="image/png"
				sizes="128x128"
				href="https://a.storyblok.com/f/187315/512x512/7499e4db49/android-chrome-512x512.png/m/128x128"
			/>
			<link
				rel="icon"
				type="image/png"
				sizes="192x192"
				href="https://a.storyblok.com/f/187315/512x512/7499e4db49/android-chrome-512x512.png"
			/>
			<link
				rel="icon"
				type="image/png"
				sizes="512x512"
				href="https://a.storyblok.com/f/187315/512x512/7499e4db49/android-chrome-512x512.png"
			/>
			<link
				rel="mask-icon"
				href="https://a.storyblok.com/f/187315/1067x1067/6b9baa318d/safari-pinned-tab.svg"
				color="#e8343c"
			/>
			<meta name="msapplication-TileColor" content="#ffffff" />

			<link rel="preconnect" href="https://connect.facebook.net" />
			<link rel="preconnect" href="https://facebook.com" />
			<link rel="preconnect" href="https://www.googletagmanager.com" />
		</>
	);
};
